import styled from 'styled-components';
import { IonSkeletonText } from '@ionic/react';

export const StyledSavedCardsSkeletonWrapper = styled.div`
  width: 100%;
  margin-inline: auto;
  ion-skeleton-text {
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const StyledSavedCardSkeleton = styled(IonSkeletonText)`
  margin-top: 25px;
  width: 100%;
  height: 60px;
  border-radius: 4px;
`;
